type ToastItem = {
  id: string
  message: string
  onClick?: () => void
}

interface ToastStackProps {
  toasts: ToastItem[]
  onDismiss: (id: string) => void
}

export default function ToastStack({ toasts, onDismiss }: ToastStackProps) {
  if (!toasts.length) {
    return null
  }

  return (
    <div
      style={{
        position: 'fixed',
        top: '18px',
        right: '18px',
        display: 'grid',
        gap: '10px',
        zIndex: 9999,
        maxWidth: '360px',
      }}
    >
      {toasts.map((toast) => (
        <div
          key={toast.id}
          role="status"
          style={{
            background: '#0F2E2A',
            color: '#F3EFE6',
            padding: '12px 14px',
            borderRadius: '12px',
            boxShadow: '0 12px 20px rgba(15,46,42,0.18)',
            fontSize: '13px',
            fontWeight: 600,
            cursor: toast.onClick ? 'pointer' : 'default',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '12px',
          }}
          onClick={() => {
            if (toast.onClick) {
              toast.onClick()
            }
          }}
        >
          <span>{toast.message}</span>
          <button
            type="button"
            onClick={(event) => {
              event.stopPropagation()
              onDismiss(toast.id)
            }}
            style={{
              border: 'none',
              background: 'transparent',
              color: '#F3EFE6',
              fontSize: '16px',
              cursor: 'pointer',
              lineHeight: 1,
            }}
            aria-label="Dismiss notification"
          >
            ×
          </button>
        </div>
      ))}
    </div>
  )
}
